import {
    DEFAULT_API_CURRENT_USER_ENDPOINT,
    DEFAULT_API_SAVE_USER_ENDPOINT,
    DEFAULT_API_UPDATE_OWN_USER_ENDPOINT
} from '../../../constants/DefaultApiEndpoints';
import HttpErrorResponseModel from '../../../models/HttpErrorResponseModel';
import CurrentUserModel from '../../../models/userinfo/CurrentUserModel';
import UserModel from '../../../models/userinfo/user/UserModel';
import configuration from '../../../utilities/configuration';
import * as EffectUtility from '../../../utilities/EffectUtility';

export async function saveUser(user) {
  const endpoint = configuration.apiGateway + (configuration.apiSaveUserEndpoint || DEFAULT_API_SAVE_USER_ENDPOINT);
  return EffectUtility.putToModel(UserModel, endpoint.replace(':userName', user.userName), user);
}

export async function putOwnUser(idToken) {
  const endpoint = configuration.apiGateway + (configuration.apiUpdateOwnUserEndpoint || DEFAULT_API_UPDATE_OWN_USER_ENDPOINT);
  return EffectUtility.putToModel(UserModel, endpoint, { idToken });
}

export async function getCurrentUser() {
  const endpoint = configuration.apiGateway + (configuration.apiCurrentUserEndpoint || DEFAULT_API_CURRENT_USER_ENDPOINT);
  const currentUser = await EffectUtility.getToModel(CurrentUserModel, endpoint);

  if (!(currentUser instanceof HttpErrorResponseModel) && !currentUser.email) {
    const error = new HttpErrorResponseModel();
    error.status = 200;
    error.message = 'Current user response is missing the required email';
    error.errors = [error.message];
    error.url = endpoint;
    return error;
  }

  return currentUser;
}